import { Typography } from '@mui/material';

export default function BottomSheetMessage({ children }) {
  return (
    <Typography sx={{ fontSize: '16px', color: '#AEAEB2', mt: 2 }}>
      {children}
    </Typography>
  );
}
